import { render, staticRenderFns } from "./AccountBlocked.vue?vue&type=template&id=01aba188"
import script from "./AccountBlocked.vue?vue&type=script&lang=js"
export * from "./AccountBlocked.vue?vue&type=script&lang=js"
import style0 from "./AccountBlocked.vue?vue&type=style&index=0&id=01aba188&prod&module=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports